export { default } from "./OfferDetail";
